import { render, staticRenderFns } from "./AdministrationPage.vue?vue&type=template&id=6bef7fb6&scoped=true&"
import script from "./AdministrationPage.vue?vue&type=script&lang=js&"
export * from "./AdministrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef7fb6",
  null
  
)

export default component.exports